<div class="mr-card-group">
  <div class="mr-card" *ngFor="let card of block.cards">
    <mat-icon
      *ngIf="card.icon"
      class="mr-card-icon"
      fontSet="material-icons-outlined"
      [attr.data-variant]="card.variant || null"
      >{{ card.icon }}</mat-icon
    >
    <div class="mr-card-text">
      <p class="mr-card-title">{{ t(card.title) }}</p>
      <div class="mr-card-body" [innerHTML]="t(card.body) | markdownHtml"></div>
    </div>
  </div>
</div>
